import _ from "lodash";
import React, { Component } from "react";
import { Div, Image, Text } from "atomize";
import ImageLazyLoad from "../common/ImageLazyLoad";
import AnimateLink from "../common/AnimateLink";
import ImageLink from "../common/ImageLink";
import { IsValidUrl } from "../../utilities/helpers";

class CaseStudyHome extends Component {
  render() {
    const { card, ...rest } = this.props;

    return (
      <AnimateLink to={`/case-study/${card.slug}`}>
        <Div
          {...rest}
          pos="relative"
          p={{ b: "120.3%" }}
          cursor="pointer"
          textColor="white"
        >
          <Div
            className="case-study-card"
            p={{ b: "120.3%" }}
            bg={card.color || "blueGray"}
            pos="absolute"
            top="0"
            left="0"
            w="100%"
            opacity="1"
            transition
            cursor="pointer"
          >
            <Div
              pos="absolute"
              top="50%"
              left="50%"
              transform="translate(-50%, -50%)"
              d="flex"
              flexDir="column"
              align="center"
              w="100%"
              h="100%"
              p={{ xs: "1rem 1rem 0.75rem", lg: "2.25rem 1.875rem 1.25rem" }}
            >
              <Div
                m={{ b: { xs: "1rem", lg: "3.25rem" } }}
                d="flex"
                flexDir="column"
                align="center"
                justify="center"
              >
                <ImageLink link={ _.get(card, "userImage.file.url")}>
                  <ImageLazyLoad
                    bgImg={_.get(card, "userImage.file.url")}
                    bgSize="cover"
                    bgPos="center"
                    w={{ xs: "2rem", sm: "2.5rem" }}
                    h={{ xs: "2rem", sm: "2.5rem" }}
                    rounded="circle"
                    m={{ b: "1rem" }}
                  />
                </ImageLink>
                <Text
                  textSize={{ xs: "caption", sm: "caption2" }}
                  textWeight="700"
                >
                  {card.userName}
                </Text>
                <Text textSize={{ xs: "tiny", sm: "caption" }} m={{ t: "1px" }}>
                  {card.companyName}
                </Text>
              </Div>
              <Div flexGrow="1" d="flex" align="start" justify="center">
                <Text
                  textSize={{
                    xs: "body",
                    md: "subheader1",
                    lg: "subheader2",
                    xl: "caption3",
                  }}
                  maxW={{ xs: "12rem", lg: "16rem", xl: "19rem" }}
                  textWeight="700"
                  textAlign="center"
                >
                  “{card.title}”
                </Text>
              </Div>
              <Div m={{ t: { xs: "1rem", lg: "5.5rem" } }}>
                <ImageLink link={_.get(card, "companyLogo.description")}>
                  <Image
                    src={_.get(card, "companyLogo.file.url")}
                    h={{ xs: "2rem", lg: "2.75rem" }}
                    w="auto"
                  />
                </ImageLink>
              </Div>
            </Div>
          </Div>
        </Div>
      </AnimateLink>
    );
  }
}

export default CaseStudyHome;
